export default __webpack_public_path__ + "static/media/business.a20bc601.svg";